<style scoped lang="less">
.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #f66c27;

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #f66c27;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
}

.exadminallli {
	width: 100%;
	padding: 20px;
	border-top: 2px solid #f66c27;
	background-color: #fff;

	.exadminlis {
		width: 100%;
		border: 1px solid #ccc;
		border-radius: 5px;
		display: flex;
		margin: 10px 0;
		padding: 20px;

		.exadminright {
			height: 40px;
			width: 100px;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			border-radius: 5px;
			border: 1px solid;
			color: #fff;
			// background-color: #a1a2a2;
			// padding: 5px;
		}

		.exadminleft {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border: 2px solid #ff0000;
			height: 50px;
			padding: 0 10px;
			color: red;
			margin-right: 20px;
			border-radius: 10px;
		}

		.exadmincenter {
			width: 75%;

			.exam-title {
				font-size: 18px;
				color: #000;
				// font-weight: 700;
			}

			.exadmintimers {
				display: flex;
				align-items: center;
				p {
					margin: 8px 0;
					margin-right: 40px;
					color: #000;
					font-size: 15px;
				}
			}

			.exadmincontentfont {
				font-size: 15px;
				color: #ababab;
			}
		}
	}

	.elpagian {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 40px 0;
	}

	.exadbtns {
		color: #409eff;
		border: 1px solid #409eff;
		text-decoration: underline;
		border-radius: 5px;
		background-color: #fff;
		height: 100%;
		cursor: pointer;
	}
}
</style>
<template>
	<div ref="homes">
		<titles titlename="我的考试" titlecontent="这里可以看到我的考试一些信息" :mbx="paths"></titles>
		<div class="choiostitle">
			<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
			<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
				<el-select @change="changesselect" clearable v-model="value" placeholder="根据试卷状态筛选">
					<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</div>
		</div>

		<div class="exadminallli">
			<div style="margin-bottom: 32px;">
				<el-radio v-model="exadminaradio" :label="0">正式试卷</el-radio>
				<el-radio v-model="exadminaradio" :label="1">模拟练习试卷</el-radio>
			</div>

			<el-empty v-if="exadminlist.length == 0" description="暂无考试信息"></el-empty>
			<div class="exadminlis" v-loading="loddings" v-for="(item, index) in exadminlist" :key="index">
				<div class="exadminleft" v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 1 && item.SSP_Status == 0">
					<p style="font-size: 16px;">倒计时</p>
					<p>{{ djtimers(item.SPA_SetExamTime) }}</p>
				</div>
				<div class="exadminleft" v-if="item.SSP_Status == 1" style="color: #04d919;border-color: #04d919;"><p style="font-size: 16px;">已完成</p></div>
				<div class="exadminleft" v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 2 && item.SSP_Status == 0" style="color: #04d919;border-color: #04d919;">
					<p style="font-size: 16px;">考试进行中</p>
				</div>
				<div v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 3 && item.SSP_Status == 0" class="exadminleft" style="color: #a1a5a8;border-color: #a1a5a8;">
					<p style="font-size: 16px;">已结束</p>
				</div>
				<div class="exadmincenter">
					<p class="exam-title">{{ item.SPA_PaperTitle }}</p>
					<div class="exadmintimers">
						<p>
							考试开始时间：
							<span style="color: red;">{{ item.SPA_SetExamTime ?? item.SSP_StartTime ?? '' }}</span>
						</p>
						<p>考试结束时间：{{ item.SPA_EndTime ?? item.SSP_EndTime ?? '' }}</p>
						<p>
							时限：
							<span style="color: red;">{{ item.SPA_Duration }}</span>
							分钟
						</p>
						<p v-if="item.SSP_Scores">
							考试成绩：
							<span style="color: red;">{{ item.SSP_Scores }}</span>
							分
						</p>
						<p>
							总分：
							<span style="color: red;">{{ item.SPA_Scores }}</span>
							分
						</p>
					</div>
					<div class="exadmincontentfont">
						<p>考试注意点：</p>
						<p>1.本次考试为线上闭卷考试，不能作弊，否则取消考试成绩！</p>
						<p>2.开考前1分钟可点击开始按钮进入考试，不允许提早进入！</p>
						<p>3.考试前10分钟后不进入考试即无法再进入考试，本次考试直接判零分！</p>
					</div>
				</div>
				<div class="exadminright">
					<div v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 1 && item.SSP_Status == 0" style="background-color: #a1a2a2;">即将开始</div>
					<div
						v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 2 && item.SSP_Status == 0"
						@click="goexamdin(item)"
						style="background-color: #04d919;border-radius: 5px;cursor: pointer;"
					>
						进入考试
					</div>
					<div v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 3 && item.SSP_Status == 1" class="exadbtns" @click="goexaminxq(item)">查看详情</div>
					<div v-if="changetimers(item.SPA_SetExamTime, item.SPA_EndTime) == 3 && item.SSP_Status == 0" style="color: red;">已超时</div>
				</div>
			</div>

			<div class="elpagian">
				<el-pagination
					@current-change="changecurr"
					background
					hide-on-single-page
					layout="prev, pager, next"
					:page-size="pagesobj.pageSize"
					:total="totalall"
					:current-page="pagesobj.pageIndex"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { GetUserSentPaper, GetDate } from '@/request/api/homesview/yunhomes/yunhom.js';

import { countdown } from '@/utils/utils.js';
import AppOptions from '@/config/AppOptions.vue';
import $ from 'jquery';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/testists/Myexamind',
					name: '我的考试'
				}
			],
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				SSP_Status: '',
				SPA_TYPE: '',
				SPA_PaperTitle: '',
				SSP_StartTime: '',
				SSP_EndTime: '',
				SPA_IsTrain: ''
			},
			totalall: 10,
			value: '',
			exadminlist: [],
			options: [
				{
					id: 1,
					name: '未开始'
				},
				{
					id: 2,
					name: '进行中'
				},
				{
					id: 3,
					name: '已结束'
				}
			],
			dates: '',
			exadminaradio: 0,
			loddings: false
		};
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		if (this.$route.query && this.$route.query?.radios) {
			this.exadminaradio = this.$route.query.radios ? 1 : 0;
		} else {
			this.pagesobj.SPA_IsTrain = this.exadminaradio == 1 ? true : false;
			this.getuserper();
		}
	},
	watch: {
		exadminaradio(val) {
			this.pagesobj.pageIndex = 1;
			this.pagesobj.SPA_IsTrain = val == 1 ? true : false;
			this.getuserper();
			// console.log(val, '更改val');
		}
	},
	methods: {
		goexamdin(itm) {
			this.$router.push('/pageme/examine?SPA_GUID=' + itm.SPA_GUID);
		},
		goexaminxq(itm) {
			let uiguid = localStorage.getItem('uiguid');
			this.$router.push('/textorexamin/examinationmanage/examinxq?SPA_GUID=' + itm.SPA_GUID + '&UI_GUID=' + uiguid + '&SSP_Scores=' + itm.SSP_Scores);
		},

		changetimers(olddata, enddate) {
			// GetDate().then(res => {
			// 	this.dates = res.data.data;
			// });
			// 创建两个日期对象
			let old_date = new Date(olddata).getTime();
			let new_date = new Date(this.dates).getTime();

			let end_date = new Date(enddate).getTime();
			// 计算两个日期之间的毫秒数
			let difftime = (old_date - new_date) / 1000;
			let difftimer = (end_date - new_date) / 1000;

			// 将毫秒数转换为小时
			var days = parseInt(difftime / 86400); // 天  24*60*60*1000
			var hours = parseInt(difftime / 3600) - 24 * days; // 小时 60*60 总小时数-过去的小时数=现在的小时数
			var minutes = parseInt((difftime % 3600) / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
			var seconds = parseInt(difftime % 60); // 以60秒为一整份 取余 剩下秒数

			// console.log(difftime,difftimer);
			if (difftimer < 0) {
				return 3;
			}
			if (difftimer > 0 && difftime < 0) {
				return 2;
			}
			if (difftimer > 0 && difftime > 0) {
				return 1;
			}
		},
		djtimers(olddata) {
			// GetDate().then(res => {
			// 	this.dates = res.data.data;
			// });
			let old_date = new Date(olddata).getTime();
			let new_date = new Date(this.dates).getTime();
			let difftime = (old_date - new_date) / 1000;
			return countdown(difftime);
		},

		changesselect(val) {
			// console.log(val,'获取')
			this.pagesobj.SSP_Status = val;
			this.pagesobj.pageIndex = 1;
			this.getuserper();
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getuserper();
		},
		async getuserper() {
			this.loddings = true;
			await GetUserSentPaper(this.pagesobj).then(res => {
				this.exadminlist = res.data.data.list;
				// this.totalall = res.data.data.
			});

			await GetDate().then(res => {
				this.dates = res.data.data;
			});

			this.loddings = false;
		}
	},
	components: {
		titles
	}
};
</script>
